// Nav icons: app/nav.ts names icons by their lucide export name. Only the icons used are
// imported (a dynamic lookup would pull all ~1,500 icons into the bundle).
import {
  House, Inbox, Tag, Users, BadgePercent, Star, ChartLine, Store, Import, Settings, Gauge, ShieldAlert, Flag, Layers,
  Receipt, UserCog, Cog, CreditCard, Wallet, ShoppingCart, Truck, Landmark, Mail, UserPlus, ListPlus, FileText, Circle,
  ShoppingBag, MessagesSquare, Repeat, Megaphone, Globe, Package, Undo2, Calculator, Bot,
  type LucideIcon,
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
  House, Inbox, Tag, Users, BadgePercent, Star, ChartLine, Store, Import, Settings, Gauge, ShieldAlert, Flag, Layers,
  Receipt, UserCog, Cog, CreditCard, Wallet, ShoppingCart, Truck, Landmark, Mail, UserPlus, ListPlus, FileText,
  ShoppingBag, MessagesSquare, Repeat, Megaphone, Globe, Package, Undo2, Calculator, Bot,
}

/** Render a nav icon by lucide name; unknown names fall back to a dot (add new names here). */
export function NavIcon({ name, className }: { name: string; className?: string }) {
  const I = ICONS[name] ?? Circle
  return <I className={className} aria-hidden />
}

/** Storix brand mark: a stacked "S" monogram in a rounded square. */
export function BrandMark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      <defs>
        <linearGradient id="bm-g" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#7c6cf6" />
          <stop offset="1" stopColor="#4b3bc6" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#bm-g)" />
      <path d="M21.5 11.2c-.9-1.6-2.9-2.7-5.4-2.7-3.3 0-5.6 1.8-5.6 4.3 0 2.4 1.9 3.5 5 4.1l1.6.3c1.9.4 2.7.9 2.7 1.9 0 1.2-1.3 2-3.3 2-2 0-3.5-.8-4.1-2.3"
        fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" />
      <circle cx="21.6" cy="22.4" r="1.7" fill="#fff" fillOpacity=".85" />
    </svg>
  )
}

/** Brand mark + wordmark. */
export function BrandLockup({ className }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`}>
      <BrandMark size={24} />
      <span className="text-md font-semibold tracking-[-0.02em] text-text">Storix</span>
    </span>
  )
}
